import { createFeature, createReducer, on } from '@ngrx/store';
import { QualityMeasureSurvey } from '@models/quality-measure-survey.model';
import { QualityMeasureSurveyActions } from '@store/actions/quality-measure-survey/quality-measure-survey.actions';

export const qualityMeasureSurveyFeatureKey = 'qualityMeasureSurvey';

export interface State {
  survey: QualityMeasureSurvey | null;
  loading: boolean;
  saving: boolean;
  exporting: boolean;
  error: string | null;
}

export const initialState: State = {
  survey: null,
  loading: false,
  saving: false,
  exporting: false,
  error: null,
};

export const reducer = createReducer(
  initialState,

  on(QualityMeasureSurveyActions.loadSurvey, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(QualityMeasureSurveyActions.loadSurveySuccess, (state, { survey }) => ({
    ...state,
    survey,
    loading: false,
    error: null,
  })),
  on(QualityMeasureSurveyActions.loadSurveyFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(QualityMeasureSurveyActions.saveSurvey, (state) => ({
    ...state,
    saving: true,
    error: null,
  })),
  on(QualityMeasureSurveyActions.saveSurveySuccess, (state) => ({
    ...state,
    saving: false,
    error: null,
  })),
  on(QualityMeasureSurveyActions.saveSurveyFailure, (state, { error }) => ({
    ...state,
    saving: false,
    error,
  })),

  on(QualityMeasureSurveyActions.exportSurvey, (state) => ({
    ...state,
    exporting: true,
    error: null,
  })),
  on(QualityMeasureSurveyActions.exportSurveySuccess, (state) => ({
    ...state,
    exporting: false,
    error: null,
  })),
  on(QualityMeasureSurveyActions.exportSurveyFailure, (state, { error }) => ({
    ...state,
    exporting: false,
    error,
  }))
);

export const qualityMeasureSurveyFeature = createFeature({
  name: qualityMeasureSurveyFeatureKey,
  reducer,
});
